import { render } from "./ValidationFieldSet.vue?vue&type=template&id=ab88659c&scoped=true&ts=true"
import script from "./ValidationFieldSet.vue?vue&type=script&lang=ts"
export * from "./ValidationFieldSet.vue?vue&type=script&lang=ts"

import "./ValidationFieldSet.vue?vue&type=style&index=0&id=ab88659c&lang=scss&scoped=true"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab88659c"]])

export default __exports__